<template>
  <div>
    <vue-signature-pad id="signature" width="100%" height="230px" ref="signaturePad" :options="options" />
    <div class="button-hanlder mt-2">
      <a-button type="danger" ghost @click.prevent="clear" v-if="showClear">
        {{ $t('button.clear') }}
      </a-button>
      <p v-if="isError">Please sign</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignaturePad',
  data: () => ({
    options: {
      penColor: '#000',
    },
    isError: false,
  }),
  props: {
    showClear: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.signaturePad.resizeCanvas();
    });
  },
  methods: {
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    submit() {
      const { data, isEmpty } = this.$refs.signaturePad.saveSignature();
      this.isError = isEmpty;
      return { data, isEmpty };
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ {
  #signature {
    margin-top: 5px;
    border: solid 1px #000;
    border-radius: 5px;
  }
  .button-hanlder {
    margin-top: 5px;
    display: flex;
    align-items: center;
    p {
      margin-bottom: 0;
      margin-left: 1rem;
      color: #fb434a;
    }
  }
}
</style>
